import { Injectable } from '@angular/core';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificacionesService {
  loader$ = new Subject<'Activar' | 'Desactivar'>();
  sbDerecho$ = new Subject<'Abrir' | 'Cerrar'>();
  metadatos$ = new Subject<any>();
  

  constructor(private snackBar: MatSnackBar) { }
  
  private abrirSnackBar(mensaje: string, titulo: string, clase: string, ilimitado: boolean) {
    const config: MatSnackBarConfig = {
        duration: ilimitado ? 0 : 5000,
        panelClass: clase
    }
    this.snackBar.open(mensaje, titulo, config);
  }
  // Barra de notificaciones
  snackbarExito(mensaje: string, titulo: string, ilimitado?: boolean) {
      this.abrirSnackBar(mensaje, titulo, 'exitoSnackbar', ilimitado ? true : false);
  }
  snackbarError(mensaje: string, titulo: string, ilimitado?: boolean) {
      this.abrirSnackBar(mensaje, titulo, 'errorSnackbar', ilimitado ? true : false);
  }
  snackbarAviso(mensaje: string, titulo: string, ilimitado?: boolean) {
      this.abrirSnackBar(mensaje, titulo, 'avisoSnackBar', ilimitado ? true : false);
  }

  cambiarEstatusLoader(estatus: 'Activar' | 'Desactivar'){
    this.loader$.next(estatus);
  }
  obtenerEstatusLoader(): Observable< 'Activar' | 'Desactivar' > {
    return this.loader$;
  }

  cambiarEstatusSbDerecho(estatus: 'Abrir' | 'Cerrar'){
    this.sbDerecho$.next(estatus);
  }
  obtenerEstatusSbDerecho(): Observable< 'Abrir' | 'Cerrar' > {
    return this.sbDerecho$;
  }

  cambiarMetadatos(metadato){
    this.metadatos$.next(metadato);
  }
  obtenerMetadatos(): Observable<any> {
    return this.metadatos$.asObservable();
  }

}
